import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CdaModalState {
  isOpen: boolean;
  cdaViewerUrl: string | null;
}

const initialState: CdaModalState = {
  isOpen: false,
  cdaViewerUrl: null
};

const modalSlice = createSlice({
  name: 'cdaModal',
  initialState,
  reducers: {
    openCdaModal: (state, action: PayloadAction<string>) => {
      state.isOpen = true;
      state.cdaViewerUrl = action.payload;
    },
    closeCdaModal: (state) => {
      state.isOpen = false;
      state.cdaViewerUrl = null;
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete('cdaViewerUrl');
      window.history.replaceState({}, '', currentUrl);
    }
  }
});

export const { openCdaModal, closeCdaModal } = modalSlice.actions;

export default modalSlice.reducer;
